import type {
  PartnerAddressV2,
  PartnerCarrierAccountV2,
  PartnerContact,
  PartnerTenant,
} from '@shipium-corp/shipium-ts-types';
import type { CarrierSettings, Contract } from '../../services/FP_FulfillmentContextService/types';
import type { HydratedCarrierAccount, HydratedCarrierSettings, HydratedContract, ValidationInfo } from '../types';
import { hydrateCarrierAccount } from './hydrateCarrierAccount';
import { hydrateGenericBaseAsset } from './hydrateGenericBaseAssest';

export interface HydrateContractParams {
  addresses: Record<string, PartnerAddressV2>;
  carrierAccounts: Record<string, PartnerCarrierAccountV2>;
  carrierSettings: Record<string, CarrierSettings>;
  contract: Contract;
  contacts: Record<string, PartnerContact>;
  tenants: PartnerTenant[];
}

const createValidationInfo = (
  hydratedCarrierAccount: HydratedCarrierAccount,
  hydratedCarrierSettings: HydratedCarrierSettings,
): ValidationInfo => {
  const isValid =
    hydratedCarrierAccount.validationInfo.configurationValid &&
    hydratedCarrierSettings.validationInfo.configurationValid;
  const isComplete =
    hydratedCarrierAccount.validationInfo.configurationComplete &&
    hydratedCarrierSettings.validationInfo.configurationComplete;
  const errors = [...hydratedCarrierAccount.validationInfo.errors, ...hydratedCarrierSettings.validationInfo.errors];
  const warnings = [
    ...hydratedCarrierAccount.validationInfo.warnings,
    ...hydratedCarrierSettings.validationInfo.warnings,
  ];
  return {
    configurationComplete: isComplete,
    configurationValid: isValid,
    errors,
    warnings,
  };
};
export const hydrateContract = ({
  carrierAccounts,
  carrierSettings,
  contract,
  contacts,
  tenants,
  addresses,
}: HydrateContractParams): HydratedContract => {
  const hydratedCarrierSettings = hydrateGenericBaseAsset(
    tenants,
    'carrierSettings',
    carrierSettings[contract.carrierSettingsId ?? ''],
  );
  const hydratedCarrierAccount = hydrateCarrierAccount(
    tenants,
    contacts,
    addresses,
    carrierAccounts[contract?.carrierAccountId ?? ''],
  );
  return {
    ...(contract ?? ({} as any)),
    carrierSettings: hydratedCarrierSettings,
    carrierAccount: hydratedCarrierAccount,
    validationInfo: createValidationInfo(hydratedCarrierAccount, hydratedCarrierSettings),
  };
};
